import React from "react";
import { useNavigate } from 'react-router-dom';
import "./deleteChnnelConfir.css";
import axios from "../../../../../axios";
import { IP } from "../../../../../internalServer";
import assets from "../../../../../assets/assets";

const DeleteChnnelConfir = ({ communityId, community, setClickDelete }) => {
  const navigate = useNavigate();
  let user_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const handleDelete = async () => {
    try {
      let res = await axios.delete(`/api/v1/community/delete/${communityId}`, {
        data: { user_id },
      });
      if (res) {
        const res1 = await axios.get(
          `/api/v1/community/post/getByUserId/teacher/${user_id}?_page=1&_limit=20&sortBy=-1`
        );
        console.log(res1);
        if (res1 && res1.data.data.length === 0) {
          navigate("/CreateCommunity");
        }
        else {
          res && navigate("/TotalCommuPost");
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <div className=" delete_channel_transprant_body ">
        <img
          src="/images/cross-circle3.svg"
          className=" delete_channel_close_btn"
          alt=""
          onClick={(e) => setClickDelete(false)}
        />
        <div className=" p-3 d-flex align-items-center justify-content-center flex-column delete_channel_container shadow">
          <div className="gap-2 mb-5 d-flex align-items-center justify-content-center">
            <img
              className="post_community_profile"
              src={`${community?.profile_picture
                  ? `${IP}${community?.profile_picture?.substring(
                    community?.profile_picture?.indexOf("/")
                  )}`
                  : `/images/channal pic3.svg`
                }`}
              alt=""
              onError={(e) => {
                e.target.src = assets.CommunityImg
              }}
            />
            <span>{community.community_name}</span>
          </div>
          <div className=" col-12 d-flex align-items-center justify-content-center flex-column text-center">
            <span className="mb-3">
              Are you sure you want to delete this channel?
            </span>
            <div className="col-12 p-0 gap-3 flex-wrap d-flex justify-content-center ">
              <button
                className="btn btn-danger col-sm-5  delete_btn"
                onClick={handleDelete}
              >
                Yes
              </button>
              <button
                className="btn btn-danger col-sm-5 delete_btn"

                onClick={(e) => setClickDelete(false)}
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeleteChnnelConfir;
